import 'babel-polyfill'
// import objectFitImages from 'object-fit-images'
import './ie11'
import './header'
import './content'
import './footer'
import whatInput from 'what-input'
import './selects'
import './load-more'
import './countdown'
import './ad-tracking'
import './modals'
import './membership-slider'
import './testimonials-slider'
import { Fancybox } from "@fancyapps/ui/dist/fancybox/fancybox.esm.js";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

jQuery(document).ready(function (e) {

    Fancybox.bind('[data-fancybox]', {
        //
    });

    if (jQuery(window).width() >= 768) {

        // Get all the landing-page__block__info elements
        var blockInfos = jQuery('.landing-page__block__info');

        // Get the height of the tallest landing-page__block__info element
        var maxHeight = 0;
        blockInfos.each(function() {
            var height = jQuery(this).outerHeight();
            if (height > maxHeight) {
                maxHeight = height;
            }
        });

        // Set the height of all the landing-page__block__info elements to the tallest height
        blockInfos.css('min-height', maxHeight);
    }

});





import 'flickity/dist/flickity.pkgd'
import vidim from 'vidim/dist/vidim'

window.vidim = vidim

const splashSlider = jQuery('.splash__holder'),
    splashSlides = jQuery('.splash__holder .splash')

let splashVideoPrev

if (splashSlider.length > 0 && splashSlides.length > 1) {

    var carousel = splashSlider.flickity({
        cellSelector: '.splash',
        prevNextButtons: false,
        autoPlay: false,
        pauseAutoPlayOnHover: false,
        wrapAround: true,
        pageDots: true,
        cellAlign: 'center',
        // draggable: true,
        arrowShape: {
            x0: 80,
            x1: 60, y1: 50,
            x2: 65, y2: 45,
            x3: 20
        }
    })



    setTimeout(function () {
        if(jQuery('.splash0').hasClass('splash--video')){
            splashSlider.flickity('select', 0)
        }
    }, 3000)

    let splashSliderData = splashSlider.data('flickity')

    splashSlider.on('select.flickity', function () {
        if (splashVideoPrev !== undefined) {
            splashVideoPrev.pause()
        }

        if (jQuery(splashSliderData.selectedElement).hasClass('splash--video')) {

            splashVideoPrev = window[`splash${splashSliderData.selectedIndex}`]
            window[`splash${splashSliderData.selectedIndex}`].play()

        }
    })

    // previous
    jQuery('.button--previous').on( 'click', function() {
      carousel.flickity('previous');
    });
    jQuery('.button--previous').on( 'keypress', function(e) {
        if(e.which == 13) {
            carousel.flickity('previous');
            setTimeout(() => {
            const splashSlides = jQuery('.splash__holder .splash')

            splashSlides.each(function( e ) {
                console.log('it happens?');
                if( !jQuery(this).hasClass('is-selected') ){
                    jQuery(this).find('*').attr('tabindex', '-1')
                }else{
                    jQuery(this).find('.splash__action').attr('tabindex', '0')
                }
            })
        }, 500);
        }
    });
    // next
    jQuery('.button--next').on( 'click', function() {
      carousel.flickity('next');
    });
    jQuery('.button--next').on( 'keypress', function(e) {
        if(e.which == 13) {
            carousel.flickity('next');
            setTimeout(() => {
            const splashSlides = jQuery('.splash__holder .splash')
            splashSlides.each(function( e ) {
                if( !jQuery(this).hasClass('is-selected') ){
                    jQuery(this).find('*').attr('tabindex', '-1')
                }else{
                    jQuery(this).find('.splash__action').attr('tabindex', '0')
                }
            })
            }, 500);
        }
    });
}
